<script>
    import { onMount } from "svelte";
    
    // Bindings
    export let title = undefined;
    export let subtitle = undefined;
    export let poptext = undefined;
    export let flag = undefined;
    export let trend = undefined;
    export let p1 = 0;
    export let p2 = 0;
    export let chartData = undefined;
    export let chartData2 = undefined;
    export let switchgraph = false;
    export let antallChart1 = 0;
    export let viewLabel = false; 
    
    $: viewSinceStart = false;
    let active = true;
        
    // Components
    import BarLine from "../charts/BarLine.svelte";
    import Toolpop from "../Toolpop.svelte";

       
</script>
    
    <div class="chartcard card card-col-12">
        <div class="chartcard header">
            <h1 class="chartcard header__title">{title}</h1>
            {#if poptext !== undefined}
            <Toolpop text={poptext} title={subtitle} direction="bottom right"/>
          {:else}
          <p class="chartcard header__subtitle">{subtitle}</p>
          {/if}
        </div>
        <div class="chartcard controllers">
            {#if switchgraph}
            <div class="chart-buttons">
                <div class="btn-group chartcard__btn-switch">
                    <button class="btn btn-border btn__not-active {viewSinceStart ? '' : 'active'}" on:click={() => viewSinceStart = false}>Siste {antallChart1} dager</button>
                    <button  class="btn btn-border btn__not-active {viewSinceStart ? 'active' : ''}"  on:click={() => viewSinceStart = true}>Totalt</button>
              </div> 
            </div>
            {/if}
            <div class="chart-labels-group">
                <div class="chart-label">
                    <svg class="icon">
                        <rect width="100" height="100"  />
                      </svg>
                    <p class="text">Nye</p>
                </div>
                <div class="chart-label">
                    <svg class="icon-line">
                        <line x1="2" y1="8" x2="18" y2="2" />
                      </svg>
                      <p class="text">Snitt 7 dager</p>
                    </div>
            </div>
        </div>
        <div class="chartcard chart">
            {#if viewSinceStart}
                <BarLine data={chartData2} strokeWidth={2}/>
            {:else}
            {#if switchgraph}
            <BarLine data={chartData} />                    
            {:else}
            <BarLine strokeWidth={2} data={chartData} />                    
            {/if}
            {/if}
        </div>
        <div class="chartcard footer">
            {#if p1}
            <div class="footer-group">
                <p class="footer-group__text">{p1}</p>
                <p class="footer-group__label">nye i går</p>
            </div>
            {/if}
            
            <div class="footer-group">
                <p class="footer-group__text">{p2}</p>
                <p class="footer-group__label">totalt</p>
            </div>
        </div>
    </div>
    
    <style lang="scss">
    .chartcard {
        display: flex;
        flex-direction: column;

        &.header {
            display: flex;
            flex-direction: column;
            &__title {
                font-size: fontsize('std');
                font-weight: 500;
                margin: 0;

            }
            &__subtitle {
                font-size: fontsize('std');
                font-weight: 400;
                margin: 0;
                display: flex;
                flex-direction: row;
            }
        }

        &.chart {
            height: 100px;
            padding: 0 .5rem 0 0;
            @include desktop {
                height: 180px;
            }
        }

        &.controllers {
            display: flex;
            margin-bottom: 1.5rem;
       
            @include desktop {
                flex-direction: row;
                justify-content: space-between; 
            }            

            .chart-labels-group {
                display: flex;
                margin: 1rem 0 0 0;
            
                @include desktop {
                    margin: 0;
                    margin-right: 1.5rem;
                }
                .chart-label {
                    display: flex;
                    align-items: center;
                    

                    .text {
                        margin: 0;
                    }
                    
                    .icon {
                        height: 10px;
                        width: 10px;
                        fill: color('red-light-2');
                        margin-right: .3rem;
                    }
                    .icon-line {
                        height: 10px;
                        width: 20px;
                        stroke-width: 3px;
                        stroke: color('red');
                        margin-right: .3rem;
                    }

                    &:not(:first-child) {
                        margin-left: 1rem;
                    }
                }
            }
        }

        &.footer {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: .8rem;
            .footer-group {
                display: flex;
                flex-direction: column;
                align-items: center;
                &__text {
                    margin: 0;
                    font-weight: 400;
                    font-size: fontsize('xl');
                }
                &__label {
                    margin: 0;
                    font-size: fontsize('md');
                }
                &:not(:first-child) {
                    margin-left: 2rem;
                }
            }   
        }
    }
    </style>
    